import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatNumber } from "service";

const Header = ({ props }) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const address = useSelector((state) => state.address_web3);
  const user = useSelector((state) => state.user);
  const [sttApprove, setSttApprove] = useState(false);
  const [balance, setBalance] = useState(0);

  const onConnect = () => {
    if (window.ethereum) {
      window.ethereum.enable().then(() => { });
    }
  };

  const onClick = () => {
    dispatch({
      type: "ACTIVE",
      payload: !state.active,
    });
  };

  const intervalRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {

        let stt = window.localStorage.getItem("sttApprove");
        let balance = window.localStorage.getItem("balance");
        setSttApprove(stt);
        setBalance(balance);

        // console.log(stt, balance);

        // console.log(data);
      } catch (error) {
        // console.error("Error checking staking approval:", error);
      }
    };

    intervalRef.current = setInterval(fetchData, 1000);

    return () => clearInterval(intervalRef.current); // Cleanup on unmount
  }, []);

  return (
    <header className={state.active ? "site-header" : "site-header"}>
      <div className="menu-and-brand">
        <img
          className="icon-menu-open"
          src="/assets/images/logo.png"
          alt="icon menu open"
          style={{ width: 60 }}
        />
      </div>
      <div className="site-header-action d-flex justify-content-end">
        <button
          className="btn btn-primary btn-connect"
          style={{ marginRight: 10 }}
          type="button"
          onClick={() => {
            window.open("assets/new.pdf");
          }}
        >
          <span className="button-title">New</span>
        </button>

        <button
          className="btn btn-primary btn-connect"
          style={{ marginRight: 10 }}
          type="button"
          onClick={() => {
            window.open("assets/USDNEW_OneTime_ForLife_Global.pdf");
          }}
        >
          <span className="button-title">Docs</span>
        </button>

        {user?.userAddress == "0x0000000000000000000000000000000000000000" ? (
          <button
            className="btn btn-primary btn-connect"
            style={{ marginRight: 10 }}
            type="button"
            onClick={() => {
              props.history.push("/login");
            }}
          >
            <span className="button-title">Add Referrer</span>
          </button>
        ) : null}

        {address ? (
          <button className="btn btn-primary btn-connect" type="button" style={{ display: 'block', fontSize: 13 }}>
            <span className="button-title">
              {address.slice(0, 6)}...{address.slice(-4)}
            </span>
            <div style={{ fontSize: 12 }}>{formatNumber(balance)} USDT</div>
          </button>
        ) : (
          <button
            className="btn btn-primary btn-connect"
            type="button"
            onClick={onConnect}
          >
            <span className="button-title">Connect</span>
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;
